import { Link } from 'react-router-dom';
import logo from '../assets/Aanya-homes-logo.png'
import { motion } from 'framer-motion';

export default function Footer() {
    return (
        <div className="text-white">
            <hr />
            <br />
            <div className='border-red m-auto'>
                <div>
                    <div className="container w-[82vw] m-auto py-10">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-15">
                            <div className="flex flex-col items-center md:items-start gap-5 mb-5">
                                <h2 className="text-xl md:text-2xl text-white font-bold mb-4">About</h2>
                                <Link to="/about" className="hover:text-gray-700">Our story</Link>
                                <Link to="/contact" className="hover:text-gray-700">Contact us</Link>
                                <Link to="/privacy-notice" className="hover:text-gray-700">Privacy notice</Link>
                            </div>
                            <div className="flex flex-col items-center md:items-start gap-5 mb-5">
                                <h2 className="text-xl md:text-2xl text-white font-bold mb-4">Companies With Us</h2>
                                <Link to="/companies/BhutaniInfraNoida" className="hover:text-gray-700">Bhutani Infra Noida</Link>
                                <Link to="/companies/YugenInfra" className="hover:text-gray-700">Yugen Infra</Link>
                                <Link to="/companies/SignatureGlobal" className="hover:text-gray-700">Signature Global</Link>
                            </div>
                            <div className="flex flex-col items-center md:items-start gap-5 mb-5">
                                <h2 className="text-xl md:text-2xl text-white font-bold mb-4">Customer Care</h2>
                                <p>Timings: 09 AM - 07 PM (Mon - Sun)</p>
                                <a href="tel:+917027070207" className="hover:text-gray-700">Call: +91 7027070207</a>
                                <a href="mailto:aanyahomes@gmail.com" className="hover:text-gray-700">E-Mail: aanyahomes@gmail.com</a>
                            </div>
                            <div className="flex justify-center md:justify-start items-center border-0px-solid-red">
                                <Link to="/">
                                    <img src={logo} alt="logo" className="h-32 md:h-40 ml-0 sm:ml-5" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="opacity-20" />
            <div className="py-8 bg-black/20">
                <div className="container w-[82vw] m-auto flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="text-gray-400 text-sm text-center md:text-left">
                        &copy; {new Date().getFullYear()} G.A.H Aanya Homes PVT.LTD. All rights reserved.
                    </div>
                    
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="flex flex-col md:flex-row items-center gap-4"
                    >
                        <div className="flex items-center gap-2 text-sm text-gray-300">
                            <span>Designed & Developed by</span>
                            <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
                                Ritik Singh
                            </span>
                        </div>
                        
                        <div className="hidden md:block w-px h-4 bg-gray-700"></div>
                        
                        <motion.a 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/917217729644?text=Hi Ritik, I saw the Aanya Homes website and I'm interested in building a professional website for my business."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-5 py-2 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 transition-colors text-xs font-bold tracking-wide uppercase flex items-center gap-2"
                        >
                            Get Your Website
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </motion.a>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}